import { setOption, subscribeToOption } from "../../Utilities/Platform/Options/Options";
import type BaseDataSource from "../_Bases/BaseDataSource";

if(process.env.NODE_ENV !== "test") {
    performance.mark("SF-DATA-SOURCE-START");
}

let resolvedDataSource: false | BaseDataSource = false;

export const setDataSource = (dataSource: BaseDataSource): void => {
    resolvedDataSource = dataSource;
};

let resolveAttempts = 0;

/**
 * Determine the data source to use depending upon platform
 */
export function determineDataSource(): Promise<BaseDataSource> {
    if(!resolvedDataSource) {
        if(resolveAttempts > 3) {
            throw new Error("Unable to resolve the database");
        }

        return new Promise((res, rej) => {
            resolveAttempts++;
            setTimeout(() => {
                determineDataSource().then(res).catch(rej);
            }, 100);
        });
    }

    return Promise.resolve(resolvedDataSource);
}

export const getCurrentDatabaseVersion = (): Promise<number | undefined> => {
    return determineDataSource()
        .then(source => source.getVersion());
};

let databaseRequiresUpdating = false;

export const setDatabaseNeedsUpdating = (): void => {
    databaseRequiresUpdating = true;
};

export const doesDatabaseNeedUpdating = (): boolean => databaseRequiresUpdating;

let stillUnknown = false;

subscribeToOption("_latest_database_version", async (option, newValue) => {
    const currentVersion = await getCurrentDatabaseVersion();

    if(typeof currentVersion === "undefined") {
        return;
    }

    if(newValue === "unknown") {
        stillUnknown = true;
        setTimeout(() => {
            if(!stillUnknown) {
                return;
            }

            setOption("_latest_database_version", currentVersion);
        }, Math.random() * (2000 - 50) + 50);

        return;
    } else if(newValue < currentVersion) {
        setOption("_latest_database_version", currentVersion);
    }

    stillUnknown = false;
});

subscribeToOption("_database_refresh", async (option, newValue) => {
    if(newValue === "unknown") return;

    if(newValue === "force") {
        window.location.reload();

        return;
    }

    const currentVersion = await getCurrentDatabaseVersion();

    if(typeof currentVersion === "undefined" || currentVersion < newValue) {
        window.location.reload();

        return;
    }

    setTimeout(() => {
        window.location.reload();
    }, Math.random() * (500 - 50) + 50);
});
